import React, { useState } from 'react';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import queryString from 'query-string';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import * as ContactActions from '../../../actions/contactActions';

import defaultClasses from '../../../components/BobTableContextMenu.module.css';

const ContactsTableContextMenu = ({
    history,
    dataItem,
    deleteContactData,
    setSelectedContact,
    ...props
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleOpen = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleEditContact = contact => {
        const queryValues = queryString.parse(history.location.search);
        queryValues.contactId = contact.id;
        queryValues.userId = contact.userId;
        const queryValuesString = queryString.stringify(queryValues);
        history.push(`/v2/dashboard/contacts?${queryValuesString}`);
        setSelectedContact(contact);
    };

    const handleDelete = async contact => {
        await deleteContactData(contact);
    };

    return (
        <React.Fragment>
            <Button
                aria-owns={open && 'render-props-menu'}
                aria-haspopup="true"
                onClick={handleOpen}
                className={defaultClasses.toggleButton}
            >
                <i className="fas fa-ellipsis-h" />
            </Button>
            <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            // eslint-disable-next-line react/jsx-closing-bracket-location
            >
                <MenuItem
                    onClick={() => handleEditContact(dataItem)}
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                >
                    <span className="material-icons-outlined md-18">
                        edit
                    </span>
                    Edit
                </MenuItem>
                <MenuItem
                    onClick={() => handleDelete(dataItem)}
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                >
                    <span className="material-icons-outlined md-18">
                        delete
                    </span>
                    Delete
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
};

const mapDispatchToProps = {
    ...ContactActions
};

export default withRouter(connect(null, mapDispatchToProps)(ContactsTableContextMenu));
